import { render, staticRenderFns } from "./Validate.vue?vue&type=template&id=b59f8fc6"
import script from "./Validate.vue?vue&type=script&lang=js"
export * from "./Validate.vue?vue&type=script&lang=js"
import style0 from "./Validate.vue?vue&type=style&index=0&id=b59f8fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports